<template>
  <div class="dashboard-layout-content-wrapper">
    <div class="absolute-wrapper">
      <div class="relative-wrapper">
        <transition name="fade" mode="out-in">
          <router-view class="router-view"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
  export default {}
</script>

<style>

.router-view > div {
  flex-basis: 100%;
}

</style>

<style scoped>
  
  .dashboard-layout-content-wrapper {
    position: relative;
    flex-grow: 1;
  }

  .absolute-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .relative-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .router-view {
    display: flex !important;
    padding: 14px;
    width: 100%;
    min-height: 100% !important;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
